import type RefundCounterpartyBankRequest from "entities/refundCounterpartyBankRequest";
import type TransferRefundPayment from "entities/refundTransferPaymentResponse";
import type TransferCounterpartyBank from "entities/transferCounterpartyBankResponse";
import TransferPaymentType from "../../../../entities/transferPaymentType";

function excludeCounterPartyBankPropertiesByRefundPaymentType(
  counterpartyBank: RefundCounterpartyBankRequest | TransferCounterpartyBank,
  transferRefundType: TransferPaymentType
) {
  const { name, cityAddress, countryCode, codeType, ...baseProperties } = counterpartyBank;
  const modifiedBankAccount = baseProperties as RefundCounterpartyBankRequest;

  if (transferRefundType === TransferPaymentType.Foreign) {
    modifiedBankAccount.codeType = codeType;
    modifiedBankAccount.countryCode = countryCode;
    modifiedBankAccount.cityAddress = cityAddress;
    modifiedBankAccount.name = name;
  }

  return modifiedBankAccount;
}

export function excludeRefundPaymentPropertiesByType(transferRefundPayment: TransferRefundPayment) {
  const {
    counterpartyBank,
    counterpartyName,
    counterpartyCountryCode,
    counterpartyStreetAddress,
    counterpartyCityAddress,
    ...baseProperties
  } = transferRefundPayment;

  const transferRefundPaymentWithExcludedProperties = baseProperties as TransferRefundPayment;

  if (
    transferRefundPayment.transferType === TransferPaymentType.Sepa ||
    transferRefundPayment.transferType === TransferPaymentType.Foreign
  ) {
    transferRefundPaymentWithExcludedProperties.counterpartyCityAddress = counterpartyCityAddress;
    transferRefundPaymentWithExcludedProperties.counterpartyCountryCode = counterpartyCountryCode;
    transferRefundPaymentWithExcludedProperties.counterpartyStreetAddress = counterpartyStreetAddress;
    transferRefundPaymentWithExcludedProperties.counterpartyName = counterpartyName;
  }

  transferRefundPaymentWithExcludedProperties.counterpartyBank = excludeCounterPartyBankPropertiesByRefundPaymentType(
    counterpartyBank,
    transferRefundPayment.transferType
  );

  return transferRefundPaymentWithExcludedProperties;
}
